import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(2),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,
    },
    header: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'baseline',
      gap: theme.spacing(0.5),
      minWidth: 0,
      color: COLORS.text.primary,
    },
    icon: {
      fontSize: theme.typography.pxToRem(8),
      color: COLORS.error.active,
    },
    issue: {
      color: COLORS.error.active,
    },
    explanation: {
      marginTop: theme.spacing(2),
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'DetectedViolation' }
);
